<template>
  <div>
    <header class="modal-header">
      <h3 class="modal-title">Activate Account</h3>
    </header>
    <div class="modal-body">
      <b-form>
        <b-form-group
          label="USERNAME:"
          label-for="username">
          <b-form-input
            id="username"
            type="text"
            v-model="userAccount.USER_NAME"
            disabled
            required>
          </b-form-input>
        </b-form-group>
        <b-row align-v="center">
          <b-col sm="6">
            <b-form-group
              label="User Module:"
              label-for="userService">
              <multiselect
                id="userService"
                v-model="selectedModule"
                :options="userServiceModules"
                group-values="module"
                group-label="serviceName"
                track-by="moduleName"
                label="moduleName"
                :option-height="30"
                placeholder="Select Module"
                required
                @select="selectedRole = undefined" />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="User Role:"
              label-for="userRole">
              <div class="d-flex align-items-center">
                <multiselect
                  id="userRole"
                  v-model="selectedRole"
                  :options="getModuleRoles"
                  placeholder="Select User Role"
                  track-by="CODE"
                  label="NAME"
                  required
                  class="mr-2" />
                <b-btn
                  size="sm"
                  variant="success"
                  :disabled="!selectedModule || !selectedRole"
                  @click="addModule">
                  <i class="fa fa-plus" />
                </b-btn>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="mb-2">
          <b-button
            v-for="(module, idx) in modules"
            :key="idx"
            size="sm"
            pill
            variant="secondary"
            class="mr-1 mb-1"
            @click="modules.splice(idx, 1)">
            {{ `${module.moduleName} (${module.roleName})` }}
            <i class="fa fa-close" />
          </b-button>
        </div>
        <!-- <b-form-group
          label="User Role:"
          label-for="userRole">
          <multiselect
            id="userRole"
            v-model="userAccount.USER_ROLE_CODE"
            :options="userRoles"
            placeholder="Select User Role"
            track-by="CODE"
            label="NAME"
            required />
        </b-form-group>
        <b-form-group
          label="User Services:"
          label-for="userService">
          <multiselect
            id="userService"
            v-model="userAccount.USER_SERVICE_CODE"
            :options="userServices"
            :multiple="true"
            placeholder="Select User Services"
            track-by="CODE"
            label="NAME"
            required />
        </b-form-group> -->
      </b-form>
    </div>
    <footer class="modal-footer">
      <b-btn :size="'sm'" @click="$emit('close')">Cancel</b-btn>
      <b-btn :variant="'primary'" :size="'sm'" @click="handleSubmit" :disabled="isFetching">Activate</b-btn>
    </footer>
  </div>
</template>
<script>
import groupBy from 'lodash/groupBy'
import { mapGetters, mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'activate-account-modal',
  props: {
    model: Object
  },
  components: {
    Multiselect
  },
  data () {
    return {
      selectedModule: undefined,
      selectedRole: undefined,
      modules: [],
      userModules: [],
      userAccount: { ...this.model } || {},
      isFetching: false
    }
  },
  computed: {
    ...mapState('userService', {
      userServices: state => state.items
    }),
    ...mapState('userRole', {
      userRoles: state => state.items
    }),
    ...mapGetters('userProfile', [
      'getByUACode',
      'getNameByUACode'
    ]),
    getModuleRoles () {
      if (!this.selectedModule) return []
      return this.$store.getters['userRole/getModuleRoles'](this.selectedModule.moduleName)
    },
    userServiceModules () {
      return this.$store.getters['userService/getServiceModules']
    }
  },
  created () {
    this.modules = this.transformServiceCode(this.model.USER_SERVICE_CODE)
  },
  methods: {
    transformServiceCode (serviceCode) {
      let arr = []
      serviceCode.forEach((service) => {
        const tmp = service.USER_MODULE.map((module) => {
          return {
            roleName: module.USER_ROLE_NAME,
            roleCode: this.userRoles.find(o => o.NAME === module.USER_ROLE_NAME).CODE,
            moduleName: module.MODULE_NAME,
            serviceCode: service.SERVICE_CODE
          }
        })
        arr = [...arr, ...tmp]
      })
      console.log(arr)
      return arr
    },
    addModule () {
      const tmp = {
        roleCode: this.selectedRole.CODE,
        roleName: this.selectedRole.NAME,
        ...this.selectedModule
      }
      if (!this.modules.find(o => o.moduleName === tmp.moduleName)) {
        this.modules.push(tmp)
      }
      this.selectedModule = undefined
      this.selectedRole = undefined
    },
    handleSubmit (e) {
      e.preventDefault()
      this.isFetching = true
      const serviceTmp = groupBy(this.modules, 'serviceCode')
      const userServiceCode = Object.keys(serviceTmp).map((o) => {
        return {
          serviceCode: o,
          userModule: serviceTmp[o].map((service) => {
            return {
              moduleName: service.moduleName,
              userRoleCode: service.roleCode
            }
          })
        }
      })
      let payload = [{
        uaCode: this.userAccount.CODE,
        userServiceCode: userServiceCode,
      }]
      this.$store.dispatch('userAccount/activateAccount', payload).then(
        _resp => this.$emit('close'),
        _err => this.$emit('close')
      )
    }
  }
}
</script>
